import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const AssessmentCreditPackPriceService = {
    createCreditPackagePrice,
    getAllCreditPackagePrices,
    updateCreditPackagePrice,
    deleteCreditPackagePrice,
    getAllActiveLevelPrices,
    getAllActiveLevelPricesByGrade,
    getAllCreditPackagesByGrade,
    getAllActiveCreditPackagesByID,
    getLimitOfBuyCreditPackages,
    updateLimitOfBuyCreditPackages
}
async function createCreditPackagePrice(levelPrice) {
    const requestOptions = {
        method: "POST",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: levelPrice,
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-package-price/add`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCreditPackagePrices(node_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-package-price/getAllCreditPackagePrices/${node_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllActiveLevelPrices(node_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/subscription/level-prices/getAllActiveLevelPrices/${node_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllActiveLevelPricesByGrade(node_id, grade_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/subscription/level-prices/getAllActiveLevelPricesByGrade/${node_id}/${grade_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllCreditPackagesByGrade(node_id, grade_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/subscription/level-prices/getAllActiveCreditPackagesByGrade/${node_id}/${grade_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllActiveCreditPackagesByID(node_id, user_id) {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-package-price/getAllActiveCreditPackagesByID/${node_id}/${user_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateCreditPackagePrice(levelPrice, level_price_id) {
    const requestOptions = {
        method: "PUT",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
        body: levelPrice,
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-package-price/update/${level_price_id}`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteCreditPackagePrice(credit_package_price_id, form_list_id) {
    const configOptions = {
        method: "DELETE",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/assessment-subscription/credit-package-price/delete/${credit_package_price_id}/${form_list_id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getLimitOfBuyCreditPackages() {
    const requestOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/credit-buy-limit-setting/get`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateLimitOfBuyCreditPackages(data) {
    console.log("Data to be sent:", data);
    const requestOptions = {
        method: "PUT",
        headers: {
            ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
            "Content-Type": "application/json",
        },
         body: JSON.stringify(data),
    };
    const response = await fetch(
        `${config.oat_api_url}/manage/credit-buy-limit-setting/update`,
        requestOptions
    );
    return APIHandler.handleResponse(response);
}